import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from 'react-router-dom';

import clsx from 'clsx';
import Link from '@material-ui/core/Link';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import FormControl from '@material-ui/core/FormControl';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import NativeSelect from '@material-ui/core/NativeSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';

// icon
import VisibilityIcon from '@material-ui/icons/Visibility';
import PeopleIcon from '@material-ui/icons/People';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// images
import Th from '../../assets/fag/th.png';
import En from '../../assets/fag/en.png';

// private route
import PrivateRoute from '../../routes/privateRoute';

// component
import Sidebar from '../Sidebar';
import Login from './login';
import DataViews from './dataView/DataViews';
import User from './user/User';
import LinkSite from './LinkSite';

// style
import { styles } from './style';
import './style.scss';
import '../../global/styles.scss';
import './styles.css';

// logo
import Logo from '../../assets/logos/logo-onwr.png';

// route
import Routes from '../../routes/Routes';

// auth
import AuthService from '../../services/auth.service';

// context
import ModeContext from '../../context/ModeContext';

// GoogleAnalytics
import GA from '../../utils/tracking/GoogleAnalytics';

const initPath = `/${process.env.REACT_APP_PATH}`;
const useStyles = makeStyles(styles);

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={2} m={1}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

export default function Header() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [open] = React.useState(false);
  const [state, setState] = React.useState({
    right: false,
    province: '10',
  });

  const {
    selectList, currentSelectList, currentTextSelectList, handleSelectListChange, handleModeClick, currentMode,
  } = useContext(ModeContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
    >
      <AppBar position="static" color="inherit" style={{ background: 'transparent', boxShadow: 'none' }}>
        <Tabs value={value} onChange={handleChange} aria-labelledby="simple tabs example" textColor="secondary" indicatorColor="secondary" variant="fullWidth">
          <Tab icon={<VisibilityIcon />} label={t('ดูข้อมูล')} {...a11yProps(0)} textColor="colorPrimary" />
          <Tab icon={<PeopleIcon />} label={t('สำหรับเจ้าหน้าที่')} {...a11yProps(1)} style={{ whiteSpace: 'noWrap' }} />
        </Tabs>
        <Divider />
      </AppBar>
      <TabPanel value={value} index={0}>
        <DataViews />
        <Box mt={6}>
          <Grid item xs="auto" md="auto">
            <LinkSite />
          </Grid>
        </Box>
        {/* <Hidden mdUp>
          <Box mt={6}>
            <Grid item xs="auto" md="auto">
              <a href={`${initPath}`} className="navbar-moblie-item">
                <Typography variant="h6">{t('ภาพรวมประเทศไทย')}</Typography>
              </a>
              <NavLink to={`${initPath}intro`} activeClassName="navbar-active" className="navbar-moblie-item">
                <Typography variant="h6">{t('แนะนำการใช้งาน')}</Typography>
              </NavLink>
              <NavLink to={`${initPath}about`} activeClassName="navbar-active" className="navbar-moblie-item">
                <Typography variant="h6">{t('เกี่ยวกับเรา')}</Typography>
              </NavLink>
              <NavLink to={`${initPath}contact`} activeClassName="navbar-active" className="navbar-moblie-item">
                <Typography variant="h6">{t('ติดต่อเรา')}</Typography>
              </NavLink>
            </Grid>
          </Box>
          <Divider />
          <Box mt={2}>
            <Typography noWrap variant="caption">
              Change Language
            </Typography>
            <MenuItem>
              <ListItemIcon>
                <img src={En} alt="Eng" />
              </ListItemIcon>
              <ListItemText primary="ENG" />
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <img src={Th} alt="Th" />
              </ListItemIcon>
              <ListItemText primary="ไทย" />
            </MenuItem>
          </Box>
        </Hidden> */}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Login />
        <User />
      </TabPanel>
    </div>
  );

  const currentTH = i18n.language === 'th';
  const currentEN = i18n.language === 'en';

  const currentLang = currentTH ? {
    label: 'th', src: Th, Text: 'ไทย', alt: 'ภาษาไทย',
  } : {
    label: 'en', src: En, Text: 'En', alt: 'English',
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Router>
      <AppBar
        color="inherit"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <div className={classes.layout}>
          <Toolbar disableGutters>
            <div style={{ width: '100%' }}>
              <Grid container direction="row" alignItems="center" style={{ width: '100%' }}>
                <Grid item display="flex">
                  <Link href={initPath}>
                    <img src={Logo} alt="onwr" className={classes.imgLogo} />
                  </Link>
                </Grid>
                <Hidden smDown>
                  <Grid item display="flex">
                    <Link href={initPath}>
                      <Typography noWrap className={classes.titleTH}>
                        สำนักงานทรัพยากรน้ำแห่งชาติ
                      </Typography>
                      <Typography noWrap className={classes.titleEN}>
                        Office of the National Water Resources
                      </Typography>
                    </Link>
                  </Grid>
                </Hidden>
                <Grid item xs={7} sm md>
                  <Grid container justifyContent="center" alignItems="center">
                    <Hidden mdUp>
                      <Grid item xs sm={5}>
                        <Link href={initPath}>
                          <Typography noWrap className={classes.titleTHMobile}>
                            {t('สถานการณ์น้ำประเทศไทย')}
                          </Typography>
                        </Link>
                      </Grid>
                    </Hidden>
                    {/* {AuthService.isLogin()
                      ? (
                        <Hidden smDown>
                          <Grid item xs sm={4} md="auto">
                            <FormControl component="fieldset" className={classes.affected}>
                              <RadioGroup row aria-label="mode" name="mode" value={currentMode} style={{ display: 'flow-root' }}>
                                <FormControlLabel
                                  id="select-province"
                                  value="province"
                                  control={<Radio color="primary" onClick={handleModeClick} />}
                                  label={<Typography variant="subtitle2" className={classes.controlProvinces}>{t('จังหวัด')}</Typography>}
                                />
                                <FormControlLabel
                                  id="select-basin"
                                  value="basin"
                                  control={<Radio color="primary" onClick={handleModeClick} />}
                                  label={<Typography variant="subtitle2" className={classes.controlProvinces}>{t('ลุ่มน้ำ')}</Typography>}
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        </Hidden>
                      ) : null} */}
                    <Hidden smDown>
                      <Grid item xs sm={4} md="auto">
                        <FormControl component="fieldset" className={classes.affected}>
                          <RadioGroup row aria-label="mode" name="mode" value={currentMode} style={{ display: 'flow-root' }}>
                            <FormControlLabel
                              id="select-province"
                              value="province"
                              control={<Radio color="primary" onClick={handleModeClick} />}
                              label={<Typography variant="subtitle2" className={classes.controlProvinces}>{t('จังหวัด')}</Typography>}
                            />
                            <FormControlLabel
                              id="select-basin"
                              value="basin"
                              control={<Radio color="primary" onClick={handleModeClick} />}
                              label={<Typography variant="subtitle2" className={classes.controlProvinces}>{t('ลุ่มน้ำ')}</Typography>}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Hidden>
                    <Grid item xs sm={4} md="auto">
                      <FormControl className={`${classes.formControl} ${classes.selectProvinces}`} style={{ marginLeft: 0 }}>
                        <NativeSelect
                          labelid="main-select-filter"
                          id="main-select-filter"
                          value={currentSelectList}
                          onChange={handleSelectListChange}
                          disableUnderline
                          className={classes.buttonSelectProvinces}
                        >
                          <option aria-label={t(currentTextSelectList)} value="0">{t(currentTextSelectList)}</option>
                          {selectList !== null && selectList.map((row) => (<option key={_.uniqueId()} value={row.code} className={classes.listSelectProvinces}>{t(row.name)}</option>))}
                        </NativeSelect>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Hidden smDown>
                  <Grid item sm="auto" />
                </Hidden>
                <Hidden xsDown>
                  <Grid item xs="auto" sm="auto" md="auto" className={classes.sectionDesktop}>
                    <Grid container justifyContent="flex-end" alignItems="center">
                      {/* <Grid item>
                        <Breadcrumbs separator={<Typography className="navbar-separator">|</Typography>} aria-label="breadcrumb">
                          <a href={initPath} className="navbar-item">
                            {t('ภาพรวมประเทศไทย')}
                          </a>
                          <NavLink to={`${initPath}reportwater/events`} activeClassName="navbar-active" className="navbar-item">
                            {t('บันทึกเหตุการณ์')}
                          </NavLink>
                          <NavLink to={`${initPath}intro`} activeClassName="navbar-active" className="navbar-item">
                            {t('แนะนำการใช้งาน')}
                          </NavLink>
                          <NavLink to={`${initPath}about`} activeClassName="navbar-active" className="navbar-item">
                            {t('เกี่ยวกับเรา')}
                          </NavLink>
                          <NavLink to={`${initPath}contact`} activeClassName="navbar-active" className="navbar-item">
                            {t('ติดต่อเรา')}
                          </NavLink>
                        </Breadcrumbs>
                      </Grid> */}
                      <Grid item>
                        <Box ml={2} display="flex" justifyContent="flex-end" alignItems="center">
                          <IconButton
                            aria-label={currentLang.label}
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                            variant="contained"
                            color="primary"
                            onClick={handleClick}
                            data-cy="display-lang"
                          >
                            <img src={currentLang.src} alt={currentLang.alt} />
                            <Box pl={1} display="flex" justifyContent="center" alignItems="center">
                              <Typography variant="body2" className={classes.langTag} noWrap>
                                {currentLang.Text}
                              </Typography>
                            </Box>
                            <ExpandMoreIcon />
                          </IconButton>

                          <StyledMenu
                            id="customized-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                          >
                            <Box px={1}>
                              <Typography noWrap variant="caption">
                                {t('เปลี่ยนภาษา')}
                              </Typography>
                            </Box>
                            <Divider />

                            {currentTH && (
                              <MenuItem onClick={() => changeLanguage('en')} data-cy="change-language-web">
                                <ListItemIcon>
                                  <img src={En} alt="En" />
                                </ListItemIcon>
                                <Typography className={classes.lang} noWrap>
                                  En
                                </Typography>
                              </MenuItem>
                            )}

                            {currentEN && (
                              <MenuItem onClick={() => changeLanguage('th')} data-cy="change-language-web">
                                <ListItemIcon>
                                  <img src={Th} alt="ภาษาไทย" />
                                </ListItemIcon>
                                <Typography className={classes.lang} noWrap>
                                  ไทย
                                </Typography>
                              </MenuItem>
                            )}

                          </StyledMenu>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Hidden>
                <Grid item xs={1} sm={1} md={1} lg="auto">
                  {['right'].map((anchor) => (
                    <IconButton
                      key="key"
                      color="inherit"
                      aria-label="open drawer"
                      // edge="end"
                      onClick={toggleDrawer(anchor, true)}
                      className={`${clsx(open && classes.hide)} ${classes.buttonMenu}`}
                    >
                      <MenuIcon id="navbar-drawer-button" fontSize="large" className="navbar-menu" style={{ fontSize: '2em', color: '#757575' }} />
                    </IconButton>
                  ))}
                </Grid>
              </Grid>
            </div>
          </Toolbar>
        </div>
      </AppBar>
      {/* Cookie */}
      <CookieConsent
        location="bottom"
        buttonText="ยอมรับ"
        cookieName="PDPA-NTW"
        style={{ background: 'rgb(255, 255, 255, 0.9)', borderTop: '1px solid #ccc', zIndex: 999999 }}
        buttonStyle={{
          background: '#1876D2', color: '#fff', fontSize: '0.9em', borderRadius: 20, padding: '3px 25px', marginleft: 20, fontFamily: 'Kanit',
        }}
        expires={150}
      >
        <h4 style={{ color: '#000', lineHeight: '100%', fontFamily: 'Kanit' }}>นโยบายและคำประกาศเกี่ยวกับความเป็นส่วนตัว</h4>
        <p style={{
          color: '#666', fontSize: '0.9em', fontFamily: 'Kanit',
        }}
        >
          เราให้ความสำคัญต่อข้อมูลส่วนบุคคลของท่าน เพื่อการพัฒนาประสิทธิภาพ
          และประสบการณ์ที่ดีในการใช้งานเว็บไซต์ หากท่านใช้บริการเว็บไซต์นี้
        </p>
        <Grid container spacing={2}>
          <Grid item xs={12} md="auto"><span style={{ color: '#000' }}>ดูรายละเอียดเพิ่มเติม :  </span></Grid>
          <Grid item xs={12} sm="auto"><NavLink to={`${initPath}pdpa`}><span className={classes.pdpaPopupLink}>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</span></NavLink></Grid>
        </Grid>
      </CookieConsent>
      <div className={`${classes.layout} ${classes.topDevice}`}>
        <main>
          <div className={classes.sectionSidebar}>
            <Sidebar />
          </div>

          {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
          <Container maxWidth="xl">
            <Switch>
              {Routes().map((route) => ((route.private === true && route.private !== undefined) ? (
                <PrivateRoute
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                />
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                />
              )))}
              {GA.init('waterinfo') && <GA.RouteTracker />}
            </Switch>
          </Container>
        </main>
      </div>

      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <div className={classes.drawerHeader}>
              <IconButton id="navbar-drawer-close-button" onClick={toggleDrawer(anchor, false)}>
                <CloseIcon />
              </IconButton>
            </div>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </Router>
  );
}
